<template>
    <div class="get-more-info">
        <div class="top">
            <div class="top-text">{{ soldFormTitle }}</div>
        </div>
        <div class="form-container">
            <div class="agent-info" v-if="agentInfo">
                <AgentHeadShot class="agent-image" :agent="agentInfo" dir="width" />

                <div class="agent-des">
                    <div class="agent-name">{{ agentInfo.fullName }}</div>
                    <p class="tips">
                        {{ agentInfo.position }}
                        <span v-if="agentInfo.position && agentInfo.license">
                            | {{ licenseName || $t('md-detail-info.licenseId')
                            }}{{ agentInfo.license }}
                        </span>
                    </p>
                    <p v-if="agentInfo.phone" class="tips">
                        <a
                            :href="'tel:' + agentInfo.phone"
                            target="_top"
                            rel="noopener noreferrer"
                        >
                            {{ $ft.formatPhone(agentInfo.phone) }}
                        </a>
                    </p>
                </div>
            </div>
            <v-form
                :onSubmit="registerSubmit"
                :onSuccess="registerSubmitSuccess"
                :onError="registerSumbitError"
                ref="form"
            >
                <input-item
                    v-for="(item, index) in items"
                    :item="item"
                    :key="index"
                />
                <input
                    type="submit"
                    :value="soldFormButtonText"
                    :disabled="submitDisabled"
                    :class="{ 'submit-disabled': submitDisabled }"
                />
            </v-form>
            <div
                class="privacy-text"
                v-html="$t('md-detail-info.weRespectYourPrivacy')"
            ></div>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import util from '@/common/util';
import inputItem from '../../../components/input-item.vue';
import vForm from '../../../components/v-form.vue';
import message from '../../../mixins/message';
import { openLoginHideOtherPop } from '@/components/sign-log';

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    components: { inputItem, vForm },
    mixins: [message],
    data: function() {
        return {
            approveChecked: true,
            submitDisabled: false
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "licenseName": store => store.page?.licenseName
        }),
        ...mapState({
            "agentInfo": "agentInfo",
            "soldFormTitle": "soldFormTitle",
            "soldFormButtonText": "soldFormButtonText",
            "soldFormNameFormat": "soldFormNameFormat",
            "soldFormPhoneRequired": "soldFormPhoneRequired"
        }),
        items() {
            let readonly = !!this.user;
            let nameitems = [];
            if (this.soldFormNameFormat == 'full') {
                nameitems = [
                    {
                        name: 'fullname',
                        placeholder: this.$t('md-detail-info.fullName'),
                        defaultValue: '',
                        type: 'text',
                        readonly: readonly,
                        value: this.user ? this.user.fullName : ''
                    }
                ];
            } else {
                nameitems = [
                    {
                        name: 'firstName',
                        placeholder: this.$t('md-detail-info.firstName'),
                        type: 'text',
                        readonly: readonly,
                        value: (this.user && this.user.firstName) || ''
                    },
                    {
                        name: 'lastName',
                        placeholder: this.$t('md-detail-info.lastName'),
                        type: 'text',
                        readonly: readonly,
                        value: (this.user && this.user.lastName) || ''
                    }
                ];
            }
            let items = nameitems.concat([
                {
                    name: 'email',
                    placeholder: this.$t('md-detail-info.email') + '*',
                    defaultValue: '',
                    type: 'email',
                    readonly: readonly,
                    required: true,
                    value: this.user ? this.user.account : '',
                    validateConfig: {
                        async: '/api-site/register/hasUser?account={value}',
                        'async-callback': this.hasUserCallBack
                    }
                },
                {
                    name: 'phone',
                    placeholder:
                        this.$t('md-detail-info.phone') +
                        (this.soldFormPhoneRequired ? '*' : ''),
                    defaultValue: '',
                    type: 'tel',
                    required: this.soldFormPhoneRequired,
                    readonly: this.user && this.user.phoneNumber ? true : false,
                    value: this.user ? this.user.phoneNumber : '',
                    validateConfig: {
                        async: '/api-site/phoneValidate?phoneNumber={value}'
                    }
                },
                {
                    name: 'question',
                    placeholder:
                        this.$t('md-detail-info.message') +
                        (this.user ? '*' : ''),
                    defaultValue: '',
                    tag: 'textarea',
                    required: !!this.user
                }
            ]);
            return items;
        }
    },
    methods: {
        approveCheck() {
            this.approveChecked = !this.approveChecked;
        },
        registerSubmitSuccess(data = {}) {
            this.submitDisabled = true;
            setTimeout(() => {
                this.submitDisabled = false;
            }, 3000);
            this.formatData(data);
            if (this.user) {
                this.leaveMessage(this.onSuccessCallback);
            } else {
                this.leadRegister();
            }
        },
        registerNext() {
            if (this.inquiry) {
                this.showQuestionnaire(
                    Object.assign({}, this.questionnaire || {}, {
                        noToast: true,
                        closeCallback: () => {
                            this.onSuccessCallback();
                        }
                    })
                );
            } else {
                this.onSuccessCallback();
            }
        },
        onSuccessCallback() {
            util.toast(
                'toast',
                (this.onSubmitOption && this.onSubmitOption.toastMsg) ||
                    this.$t('md-detail-info.thanksIllGetBackTo'),
                (this.onSubmitOption && this.onSubmitOption.toastDelay) || 2000
            );
            if (this.$refs.form) {
                this.$refs.form.reset({
                    question: ''
                });
            }
        },
        hasUserCallBack(flag, error, value) {
            if (
                !flag &&
                error && error?.code === 210003
            ) {
                setTimeout(() => {
                    openLoginHideOtherPop({}, value);
                }, 1000);
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
.md-detail-info.fashion {
    .get-more-info {
        .top {
            background-image: url(//static.chimeroi.com/upload/1920.jpg);
            background-size: cover;
            padding: 0;
            height: 100px;
            color: white;
            font-size: 18px;
            line-height: 26px;
            letter-spacing: 1px;
            font-family: var(--font-bold);
            .top-text {
                height: 100%;
                background-color: rgba(8, 17, 38, 0.5);
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
            }
        }
        .form-container {
            background-color: #242a3d;
            padding: 30px;
            .agent-info {
                display: flex;
                margin-bottom: 10px;
                .agent-image {
                    height: 50px !important;
                    width: 50px !important;
                    margin-right: 16px;
                    flex: 0 0 auto;
                }
                .agent-name {
                    font-size: 15px;
                    color: #fff;
                    font-family: var(--font-bold);
                    margin-bottom: 10px;
                }
                .tips {
                    font-size: 12px;
                    color: #bfc9e4;
                }
            }
            form {
                display: flex;
                flex-wrap: wrap;
                input[type='text'],
                input[type='email'],
                input[type='tel'] {
                    background-color: #2f374f;
                    border: none;
                    color: #bfc9e4;
                    padding-left: 10px;
                    height: 40px;
                    font-size: 12px;
                    width: 100%;
                    margin-top: 10px;
                }
                textarea {
                    background-color: #2f374f;
                    height: 100px;
                    color: #bfc9e4;
                    padding: 12px 0 12px 10px;
                    border: none;
                    font-size: 14px;
                    width: 100%;
                    margin-top: 10px;
                }

                .approved {
                    width: 100%;
                    color: #8b93a7;
                    font-size: 14px;
                    margin-top: 22px;
                    .checkbox {
                        float: left;
                        border: 1px solid #ebecf1;
                        width: 16px;
                        height: 16px;
                        @include color-theme('color');
                        margin-right: 10px;
                        border-radius: 4px;
                        background: #fff;
                        box-sizing: inset 0 2px 4px 0 rgba(0, 10, 30, 0.1);
                        text-align: center;
                        line-height: 16px;
                        .iconfont {
                            display: none;
                            font-size: 12px;
                        }
                        &.checked {
                            .iconfont {
                                display: block;
                            }
                        }
                    }
                    &::after {
                        content: '';
                        clear: both;
                        display: block;
                    }
                }
                input[type='submit'] {
                    width: 124px;
                    margin-top: 20px;
                    margin-bottom: 30px;
                    height: 40px;
                    @include color-theme('background-color');
                    color: white;
                    text-align: center;
                    font-size: 16px;
                    font-family: var(--font-medium);
                }
                input[disabled='disabled'].submit-disabled {
                    @include input-disabled();
                }
                .input-box {
                    width: 100%;
                }
                .firstName,
                .lastName {
                    width: calc(50% - 10px);
                }
                .firstName {
                    margin-right: 20px;
                }
            }
            .privacy-text {
                color: #8b93a7;
                line-height: 18px;
                font-size: 12px;
                a {
                    color: var(--color-link, var(--color-theme, #03c9ff));
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>
